import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";

// routes
import ExperimentsPublicRoutes from "modules/experiments/routes/public";
import InsightsPublicRoutes from "modules/insights/routes/public";
import CollaborationPublicRoutes from "modules/collaboration/routes/public";

import { experimentsPublicRoutesConstants } from "../../experiments/routes/public/routesConstants";
import { insightsPublicRoutesConstants } from "modules/insights/routes/public/routesConstants";
import { collaborationPublicRoutesConstants } from "modules/collaboration/routes/public/routesConstants";

import RouteLoader from "../components/RouteLoader";

const PublicRoutes: React.FC = () => {
  return (
    <Suspense fallback={<RouteLoader />}>
      <Switch>
        <Route path={experimentsPublicRoutesConstants.root.path}>
          <ExperimentsPublicRoutes />
        </Route>

        <Route path={insightsPublicRoutesConstants.root.path}>
          <InsightsPublicRoutes />
        </Route>

        <Route path={collaborationPublicRoutesConstants.root.path}>
          <CollaborationPublicRoutes />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default PublicRoutes;
